import { IEntryDTO, IEntryFieldDTO, IEntrySectionDTO } from '@/dtos';
import { get } from './apiWrapper';

export const getEntryAPI = async (entryId: string): Promise<IEntryDTO> => {
  const ret = await get<IEntryDTO>(`/entry/${entryId}`);
  return ret;
};

export const getEntryByYearAPI = async (yearId: string): Promise<IEntryDTO> => {
  const ret = await get<IEntryDTO>(`/entry/year/${yearId}`);
  return ret;
};

export const getSectionsAPI = async (
  entryId: string,
): Promise<{ data: IEntrySectionDTO; count: number }> => {
  const ret = await get<{ data: IEntrySectionDTO; count: number }>(`/entry/${entryId}/sections`);
  return ret;
};

export const getFieldsAPI = async (
  entryId: string,
  sectionId: string,
): Promise<{ data: IEntryFieldDTO; count: number }> => {
  const ret = await get<{ data: IEntryFieldDTO; count: number }>(
    `/entry/${entryId}/sections/${sectionId}/fields`,
  );
  return ret;
};

export const getOptionsAPI = async (
  entryId: string,
  sectionId: string,
  fieldId: string,
): Promise<{ data: IEntryFieldDTO; count: number }> => {
  const ret = await get<{ data: IEntryFieldDTO; count: number }>(
    `/entry/${entryId}/sections/${sectionId}/fields/${fieldId}/options`,
  );
  return ret;
};
